import { useTranslation } from 'react-i18next';
import { components } from 'react-select';
import 'styles/common/custom-reactselect-menu.css';
// const CustomBranchMenu = (props: any) => {
//   const optionsLength = props.options ? props.options.length : 0;
//   const selectedCount = props.getValue ? props.getValue().length : 0;

//   return (
//     <>
//       <div>
//         Custom Menu with {optionsLength} options | Selected: {selectedCount}
//       </div>
//       <components.Menu {...props}>{props.children}</components.Menu>
//     </>
//   );
// };

// export default CustomBranchMenu;

export const CustomBranchMenu = (props: any) => {
  const { t } = useTranslation();
  const optionsLength = props.options ? props.options.length : 0;
  const selectedCount = props.getValue ? props.getValue().length : 0;
  const allSelected = selectedCount === optionsLength;

  const handleSelectAll = (event: any) => {
    event.stopPropagation();
    if (allSelected) {
      props.setValue([], 'select-option');
    } else {
      props.setValue(props.options, 'select-option');
    }
  };
  const handleBlur = () => {
    (document.activeElement as HTMLElement)?.blur();
  };

  return (
    <components.Menu {...props}>
      <div
        style={{
          padding: '10px',
          borderBottom: '1px solid #ccc',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          fontSize: '14px',
          fontWeight: 'bold',
        }}
      >
        {/* <label
          style={{ display: 'flex', alignItems: 'center', cursor: 'pointer' }}
          htmlFor="menu-select-all"
        > */}

        <button
          className="responsiveButton"
          // style={{
          //   backgroundColor: '#4bb189',
          //   border: 'none',
          //   borderRadius: '5px',
          //   color: 'white',
          //   height: '100%',
          //   width: '80%',
          //   transition: 'opacity 0.2s',
          // }}
          type="button"
          // style={{
          //   backgroundColor: '#4bb189',
          //   border: 'none',
          //   borderRadius: '5px',
          //   height: '100%',
          //   padding: '8px 12px',
          //   fontSize: '14px',
          //   display: 'flex',
          //   alignItems: 'center',
          //   justifyContent: 'center',
          //   cursor: 'pointer',
          //   transition: 'opacity 0.2s',
          // }}
          onMouseDown={(e) => {
            e.preventDefault();
            e.stopPropagation();
          }}
          onTouchStart={(e) => {
            e.preventDefault();
            handleSelectAll(e);
          }}
          onBlur={handleBlur}
          onClick={handleSelectAll}
          onMouseOver={(e) => (e.currentTarget.style.opacity = '0.8')}
          onMouseOut={(e) => (e.currentTarget.style.opacity = '1')}
        >
          <i className="mdi mdi-check-all" style={{ marginRight: '8px' }}></i>
          <span style={{ fontSize: '0.875rem', fontWeight: 'bold' }}>
            {t('All branches')}
          </span>
        </button>

        <span style={{ fontSize: '0.875rem', fontWeight: 'bold' }}>
          {t('Selected')}: {selectedCount}
        </span>
      </div>
      {props.children}
    </components.Menu>
  );
};
